import { Image } from "@simplybusiness/mobius";
import { TrustBannerImages } from "./TrustBannerImages";

type TrustBannerProps = {
  variant: "trustpilot" | "trustpilot_alternate";
};

export const TrustBanner = (props: TrustBannerProps) => {
  const imageConfig = TrustBannerImages[props.variant];

  const tagline =
    props.variant === "trustpilot" ? (
      <p>Trust us to find the right insurance for your business</p>
    ) : null;

  return (
    <div data-testid="trustpilot-test-id">
      <div
        className={`trust-banner__content trust-banner__content-${props.variant}`}
      >
        <Image
          src={imageConfig.src}
          alt={imageConfig.altText}
          className={`trust-banner__image trust-banner__image-${props.variant}`}
        />
        {tagline}
      </div>
    </div>
  );
};
